import { render, staticRenderFns } from "./i-video.vue?vue&type=template&id=9e653a2e&scoped=true&"
import script from "./i-video.vue?vue&type=script&lang=js&"
export * from "./i-video.vue?vue&type=script&lang=js&"
import style0 from "./i-video.vue?vue&type=style&index=0&id=9e653a2e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e653a2e",
  null
  
)

export default component.exports